import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";
import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { useSelector } from "react-redux";
import "react-toastify/dist/ReactToastify.css";

// Pages
import Home from "./components/pages/home/Home";
import SalonRequest from "./components/pages/salon/salonRequest/SalonRequest";
import Login from "./components/pages/login/Login";
import SalonInfo from "./components/pages/salon/salonRequest/SalonInfo";
import SalonList from "./components/pages/salon/salonList/SalonList";
import User from "./components/pages/user/User";
import Booking from "./components/pages/booking/Booking";
import Services from "./components/pages/service/Services";
import SalonListInfo from "./components/pages/salon/salonList/SalonListInfo";
import AdminProfile from "./components/pages/profile/AdminProfile";
import Payment from "./components/pages/payment/Payment";
import UserDetails from "./components/pages/user/UserDetails";
import Forget from "./components/pages/login/Forget";
import BookingDetail from "./components/pages/booking/BookingDetail";
import ServiceDetail from "./components/pages/service/ServiceDetail";
import Faqs from "./components/pages/supportOffers/Faqs/Faq";
import WeeklyOffers from "./components/pages/supportOffers/WeeklyOffers/WeeklyOffer";
import Coupons from "./components/pages/payment/Coupons";
import Charges from "./components/pages/payment/Charges";
import NotFound from "./components/pages/notFoundPage/NotFound";
import Complaint from "./components/pages/customerSupport/Complaints";
import ContactUs from "./components/pages/supportOffers/ContactUs/ContactUs";

function App() {
  const { dir } = useSelector((state) => state.language);

  const [user, setUser] = useState(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    return storedUser || null;
  });

  const validateToken = (token) => {
    // Simple token validation logic
    return token && token.length > 10;
  };

  useEffect(() => {
    document.documentElement.dir = dir;
  }, [dir]);

  useEffect(() => {
    // Validate token on load - only run once
    try {
      const tokenData = localStorage.getItem("token");
      // console.log("Token from localStorage:", tokenData);
      if (tokenData) {
        const token = JSON.parse(tokenData);
        if (!validateToken(token.token)) {
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          setUser(null);
        }
      }
    } catch (error) {
      console.error("Error checking authentication:", error);
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      setUser(null);
    }
  }, []); // Empty dependency array to run only once

  // Protected Route for admin access
  const ProtectedRoute = () => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    const role = storedUser?.role;
    return storedUser && role === 0 ? <Outlet /> : <Navigate to="/login" />;
  };

  return (
    <>
      <ToastContainer 
        position={dir === "rtl" ? "top-left" : "top-right"}
        rtl={dir === "rtl"}
      />
      <Router>
        <Routes>
        <Route path="*" element={<NotFound />} />
          <Route path="/login" element={<Login setUser={setUser} />} />
          <Route path="/forget" element={<Forget />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<Home />} />
            <Route path="/salon-list" element={<SalonList />} />
            <Route
              path="/salon-list/salonlist-info/:salonId"
              element={<SalonListInfo />}
            />
            <Route path="/salon-request" element={<SalonRequest />} />
            <Route
              path="/salon-request/salonrequest-info/:salonId"
              element={<SalonInfo />}
            />
            <Route path="/users" element={<User />} />
            <Route path="/users/user-details/:userId" element={<UserDetails />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/booking/booking-details/:bookingId" element={<BookingDetail />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/services-details/:categoryId" element={<ServiceDetail />} />
            <Route path="/profile-settings" element={<AdminProfile />} />
            <Route path="/payments" element={<Payment />} />
            <Route path="/coupons" element={<Coupons />} />
            <Route path="/charges" element={<Charges />} />
            <Route path="/contactUs" element={<ContactUs />} />
            <Route path="/offers" element={<WeeklyOffers />} />
            {/* <Route path="/customer/tickets" element={<Ticket />} />
            <Route path="/customer/reports" element={<Reports />} />
            <Route path="/customer/queries" element={<Queries />} /> */}
            <Route path="/customer/complaints" element={<Complaint />} />
          </Route>
        </Routes>
      </Router>
    </>
  );
}

export default App;
